import InputField from "./Input/index";
import SingleSelectDropDown from "./Dropdowns/SingleSelectDrop/index";
import MultiSelectDropDown from "./Dropdowns/MultiSelectDrop/index";
import MuiDatePicker from "./CalenderPicker";
import DateTimePicker from "./DateTimePicker";
import MuiTimePicker from "./TimePicker";
import SingleAutocomplete from "./Dropdowns/Autocomplete";
const ControlledForm = {
  Input: InputField,
  SingleSelectDrop: SingleSelectDropDown,
  MultiSelectDrop: MultiSelectDropDown,
  MuiDatePicker: MuiDatePicker,
  DateTimePicker: DateTimePicker,
  MuiTimePicker: MuiTimePicker,
  Autocomplete: SingleAutocomplete,
};
export default ControlledForm;
